export const DATE_MASK_MAX_LENGTH = 10;

export function sanitizeDateDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 8);
}

function formatDateMask(digits: string): string {
  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
}

export function parseDateFieldValue(value: string): string {
  return formatDateMask(sanitizeDateDigits(value));
}

export function formatDateFieldValue(isoDate: string | null | undefined): string {
  if (!isoDate) {
    return '';
  }

  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) {
    return '';
  }

  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
}

export function toIsoDate(maskedValue: string): string | null {
  const digits = sanitizeDateDigits(maskedValue);
  if (digits.length === 0) {
    return null;
  }

  if (digits.length !== 8) {
    return null;
  }

  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const year = Number(digits.slice(4, 8));

  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1) {
    return null;
  }

  const utcDate = new Date(Date.UTC(year, month - 1, day));
  if (
    utcDate.getUTCFullYear() !== year ||
    utcDate.getUTCMonth() !== month - 1 ||
    utcDate.getUTCDate() !== day
  ) {
    return null;
  }

  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
